export const SHOW_SUCCESS_NOTIFICATION = 'SHOW_SUCCESS_NOTIFICATION';
export const SHOW_ERROR_NOTIFICATION = 'SHOW_ERROR_NOTIFICATION';
export const SHOW_WARNING_NOTIFICATION = 'SHOW_WARNING_NOTIFICATION';

export const SET_VIEW_MODE = 'SET_VIEW_MODE';

export const SHOW_CONTENT_OVERLAY = 'SHOW_CONTENT_OVERLAY';
export const HIDE_CONTENT_OVERLAY = 'HIDE_CONTENT_OVERLAY';
export const SHOW_APP_OVERLAY = 'SHOW_APP_OVERLAY';
export const HIDE_APP_OVERLAY = 'HIDE_APP_OVERLAY';

export const DISABLE_ENTITIES_SCROLL = 'DISABLE_ENTITIES_SCROLL';
export const ENABLE_ENTITIES_SCROLL = 'ENABLE_ENTITIES_SCROLL';
